export class LuggageAmountServiceClassMatrixData{
    luggageTypeId:number;
    serviceClassId:number;
    value:number;
    luggageAmountId:number;
}